import { useQuery } from 'react-query'
import React from "react";
import { fetchSignUpsExplorer } from "../../api/dashStats"
import { CwbDataExplorer } from "../DataExplorer";

function ByDevice({ date }) {
    const fetchData = async () => {
        const { data } = await fetchSignUpsExplorer('byDevice', date)
        return data.result
    }
    const { data, error, isError, isLoading } = useQuery(['signUpsByDevice', date], fetchData, {
        refetchOnWindowFocus: false,
    })
    const dataProps = { data, error, isError, isLoading };
    return <CwbDataExplorer key={'byDevice' + date} {...dataProps } />
}
export default ByDevice